import { mdiCircle, mdiCircleMedium, mdiCircleSmall } from '@mdi/js';

export const THICKNESS_THIN = {
  key: 'THICKNESS_THIN',
  value: 0.5,
};
export const THICKNESS_NORMAL = {
  key: 'THICKNESS_NORMAL',
  value: 1.0,
};
export const THICKNESS_THICK = {
  key: 'THICKNESS_THICK',
  value: 3.0,
};

export const THICKNESS_ICONS = {
  [THICKNESS_THIN.key]: mdiCircleSmall,
  [THICKNESS_NORMAL.key]: mdiCircleMedium,
  [THICKNESS_THICK.key]: mdiCircle,
};

export const THICKNESS_TOOLBAR = [
  THICKNESS_THIN,
  THICKNESS_NORMAL,
  THICKNESS_THICK,
];
